import { CircularProgress, CircularProgressProps } from "@mui/material";
import clsx from "clsx";

import styles from "./styles.module.css";

interface IProps extends CircularProgressProps {
  wrapperClassName?: string;
}

const Loader = ({ wrapperClassName, ...restProps }: IProps) => {
  return (
    <div className={clsx(styles.wrapper, wrapperClassName)}>
      <CircularProgress {...restProps} />
    </div>
  );
};

export default Loader;
